import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@/pages/auth/auth.context";

export interface Batch {
  id: string;
  eventName?: string | null;
  batchType?: string | null;
  status: string;
  startingCheckNumber: number;
  createdByName: string;
  createdAt: string;
  totalChecks?: number;
  totalAmount?: string;
  notes?: string;
}

export function useCheckBatches() {
  return useQuery({
    queryKey: ["check-batches"],
    queryFn: async () => {
      const { data } = await axiosInstance.get("/check-batches");
      return data as Batch[];
    },
  });
}

// Types
export interface CheckBatch {
  id: string;
  eventId?: string | null;
  eventName?: string | null;
  batchType?: "EVENT" | "BONUS" | null;
  startingCheckNumber: number;
  status: "DRAFT" | "FINALIZED";
  version: number;
  createdAt: string;
  updatedAt: string;
  createdById: string;
  createdByName: string;
  notes?: string;
  includeEmployees: boolean;
  includePartners: boolean;
  totalChecks?: number;
  totalAmount?: string;
  createdChecks?: number;
  voidedChecks?: number;
  paidChecks?: number;
  paymentChecks?: PaymentCheck[];
}

export interface PaymentCheck {
  id: string;
  checkBatchId: string;
  payeeId: string;
  payeeName: string;
  payeeType: "EMPLOYEE" | "PARTNER";
  checkNumber: number;
  paymentMethod: "CHECK";
  totalAmount: string;
  status: "CREATED" | "PAID";
  issueDate?: string;
  paymentReference?: string;
  createdAt: string;
  updatedAt: string;
  paymentDetails?: PaymentDetail[];
  paymentDetailCount?: number;
}

export interface PaymentDetail {
  id: string;
  paymentCheckId: string;
  amount: string;
  paymentType: string;
  sourceId: string;
  calculationDetails: string;
  createdAt: string;
  updatedAt: string;
  paymentTypeName: string;
  sourceName: string;
}

// Fetch batch details
export function useCheckBatchDetails(batchId: string) {
  return useQuery<CheckBatch, Error>({
    queryKey: ["checkBatch", batchId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(`/check-batches/${batchId}`);
      return data;
    },
    enabled: !!batchId,
  });
}

import { useMutation } from "@tanstack/react-query";
export function useDeleteCheckBatch(batchId: string) {
  return useMutation<unknown, Error, void>({
    mutationFn: async () => {
      await axiosInstance.delete(`/check-batches/${batchId}`);
    },
  });
}
